import { __styles, mergeClasses, tokens, typographyStyles, shorthands } from '@fluentui/react-components';
export const aiGeneratedDisclaimerClassNames = {
  root: 'fai-AiGeneratedDisclaimer'
};
const useStyles = __styles({
  root: {
    Bahqtrf: "fk6fouc",
    Be2twd7: "f13mqy1h",
    Bhrd7zp: "fl43uef",
    Bg96gwp: "fcpl73t",
    Bbmb7ep: ["f1aa9q02", "f16jpd5f"],
    Beyfa6y: ["f16jpd5f", "f1aa9q02"],
    B7oj6ja: ["f1jar5jt", "fyu767a"],
    Btl43ni: ["fyu767a", "f1jar5jt"],
    z8tnut: "f1dm6uzf",
    z189sj: ["f7x41pl", "fruq291"],
    Byoj8tv: "f1mmpstq",
    uwmqm3: ["fruq291", "f7x41pl"],
    Huce71: "fz5stix",
    mc9l5x: "f14t3ns0",
    sj55zd: "f11d4kpn",
    De3pzq: "f3vzo32"
  },
  canvas: {
    z8tnut: "fz6lpwq",
    z189sj: ["fdw0yi8", "fk8j09s"],
    Byoj8tv: "f33yl79",
    uwmqm3: ["fk8j09s", "fdw0yi8"]
  }
}, {
  d: [".fk6fouc{font-family:var(--fontFamilyBase);}", ".f13mqy1h{font-size:var(--fontSizeBase100);}", ".fl43uef{font-weight:var(--fontWeightSemibold);}", ".fcpl73t{line-height:var(--lineHeightBase100);}", ".f1aa9q02{border-bottom-right-radius:var(--borderRadiusMedium);}", ".f16jpd5f{border-bottom-left-radius:var(--borderRadiusMedium);}", ".f1jar5jt{border-top-right-radius:var(--borderRadiusMedium);}", ".fyu767a{border-top-left-radius:var(--borderRadiusMedium);}", ".f1dm6uzf{padding-top:calc(var(--spacingVerticalXXS) / 2);}", ".f7x41pl{padding-right:var(--spacingHorizontalXS);}", ".fruq291{padding-left:var(--spacingHorizontalXS);}", ".f1mmpstq{padding-bottom:calc(var(--spacingVerticalXXS) / 2);}", ".fz5stix{white-space:nowrap;}", ".f14t3ns0{display:inline-block;}", ".f11d4kpn{color:var(--colorNeutralForeground3);}", ".f3vzo32{background-color:var(--colorNeutralBackground5);}", ".fz6lpwq{padding-top:calc(var(--spacingVerticalSNudge) / 2);}", ".fdw0yi8{padding-right:var(--spacingHorizontalSNudge);}", ".fk8j09s{padding-left:var(--spacingHorizontalSNudge);}", ".f33yl79{padding-bottom:calc(var(--spacingVerticalSNudge) / 2);}"]
});
export const useAiGeneratedDisclaimerStyles_unstable = state => {
  const styles = useStyles();
  state.root.className = mergeClasses(aiGeneratedDisclaimerClassNames.root, styles.root, state.mode === 'canvas' && styles.canvas, state.root.className);
  return state;
};
//# sourceMappingURL=useAiGeneratedDisclaimerStyles.js.map